type DownloadOptions = {
  filename: string;
  type?: string;
};

type DownloadContent = string | Blob | ArrayBuffer;

export function downloadFile(content: DownloadContent, options: DownloadOptions) {
  const blob =
    content instanceof Blob ? content : new Blob([content], { type: options.type || 'application/octet-stream' });

  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = options.filename;
  a.style.display = 'none';
  document.body.appendChild(a);
  a.click();

  // cleanup
  requestAnimationFrame(() => {
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  });
}
